module.exports = __webpack_public_path__ + "static/media/script.deb8a794.svg";